import React, { useEffect, useState, useRef } from 'react'
import { useForm, Controller, useWatch } from 'react-hook-form'
import _ from 'lodash';
import { isNTMSUSer } from '../../utils/roleUtils';
import { useDispatch, useSelector } from 'react-redux';
import { addImageSettings, fetchImageSettings, updateImageSettings, deleteImageSetting } from '../../services/imageSettingsServices';
import { message, Upload, Image, Button } from 'antd';
import { LoadingOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { setFormPendingCompletion, setFormPendingFunction, setNotificationData } from '../../redux/global/globalReducer';
import { ConfirmationModal } from '../Commons/Modals/ConfirmationModal';
import { ShowImageModal } from '../Commons/Modals/ShowImageModal';
import { updateFormDataOnExit } from '../../utils/formUtils';

function ImageSettingsForm({
  isFormEdit,
  setIsFormEdit,
  setIsFormDirty
}) {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    clearErrors,
    setError,
    setFocus,
    control,
    formState,
    setValue,
    reset,
  } = useForm();
  const { dirtyFields, errors, isDirty } = formState;
  const accountId = useSelector((state) => state.auth.user.accountId);
  const userType = useSelector((state) => state.auth.user.userType);
  const accountState = useSelector((state) => state.account.selectedAccount);
  const [logoData, setLogoData] = useState(null);
  const [imageSettings, setImageSettings] = useState();
  const [newLogoCheck, setNewLogoCheck] = useState(false);
  const fileInputRef = useRef(null);
  const selectedAccountState = useSelector((state) => state.account.selectedAccount);
  const [addImageSettingModal, setAddImageSettingModal] = useState(false);
  const addImageSettingToggle = () => setAddImageSettingModal(!addImageSettingModal);
  const [deleteImageSettingModal, setDeleteImageSettingModal] = useState(false);
  const deleteImageSettingToggle = () => setDeleteImageSettingModal(!deleteImageSettingModal);
  const [viewImageModal, setViewImageModal] = useState(false);
  const viewImageToggle = () => setViewImageModal(!viewImageModal);

  const isInitialRender = useRef(true);
  useEffect(() => {
    register("logo");
    setFocus("logoInput")
  }, [])

  // useEffects
  useEffect(() => {
    clearErrors();
    fillImageSettings();
    fileInputRef.current = document.getElementById('logoInput');
  }, []);

  useEffect(() => {
    const updateForm = async () => {
      await updateFormDataOnExit(
        dispatch,
        !_.isEmpty(dirtyFields),
        setIsFormDirty,
        isFormEdit,
        _.isEmpty(errors),
        handleSubmit,
        onSubmit,
      )
    }

    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    updateForm();
  }, [formState]);


  useEffect(() => {
    if (!_.isNil(imageSettings)) {
      if (imageSettings.logo != undefined && !_.isEmpty(imageSettings.logo)) {
        setImageUrl(imageSettings.logo);
        setFileList(
          [{
            uid: '-1',
            name: 'image.png',
            status: 'done',
            url: `data:image/jpeg;base64,${imageSettings.logo}`,
          },]
        );
      } else {
        setImageUrl();
        setFileList([]);
      }

    }
  }, [imageSettings])

  const onSubmit = async (payload, keepAlive = false) => {
    let response = null;

    if (isFormEdit) {
      _.set(payload, 'imageSettingsId', imageSettings.imageSettingsId);
      _.set(payload, 'accountId', imageSettings.accountId);
      
      response = await updateImageSettings(payload, keepAlive);

      dispatch(
        setNotificationData({
          type: `${response.ok ? "success" : "error"}`,
          message: `${response.ok ? "Success!" : "Error!"}`,
          description: `${response.ok ? "Successfully saved" : "Failed to save"
            } image settings.`,
        })
      );

    } else {
      _.set(payload, 'imageSettingsId', 0);
      if (isNTMSUSer(userType)) {
        _.set(payload, 'accountId', accountState.accountId != null ? accountState.accountId : accountId);
      } else {
        _.set(payload, 'accountId', accountId);
      }

      response = await addImageSettings(payload, keepAlive);

      dispatch(
        setNotificationData({
          type: `${response.ok ? "success" : "error"}`,
          message: `${response.ok ? "Success!" : "Error!"}`,
          description: `${response.ok ? "Successfully saved" : "Failed to save"
            } image settings.`,
        })
      );

    }
    if (response.ok) {
      setAddImageSettingModal();
      setIsFormEdit(true);
      setImageSettings(await response.json());
      setNewLogoCheck(false);
      dispatch(setFormPendingCompletion(false));
      reset({}, {keepValues: true});
      return true;
    }
    return false;
  }

  const fillImageSettings = async () => {

    var data = null
    if (isNTMSUSer(userType)) {
      data = selectedAccountState.accountId != null ? await fetchImageSettings(selectedAccountState.accountId) : await fetchImageSettings(accountId);
    }
    else {
      data = await fetchImageSettings(accountId)
    }
    setImageSettings(data);
    if (!_.isEmpty(data)) {

      setIsFormEdit(true);
    }
  }

  // Image uploader test

  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [fileList, setFileList] = useState([]);

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    const lessThanImageSize = file.size / 1024 / 1024 < 5;
    if (!lessThanImageSize) {
      message.error('Image must be smaller than 5MB!');
    }

    return isJpgOrPng && lessThanImageSize;
  };

  const handleAddChange = (info) => {
    const isJpgOrPng = info.file.type === 'image/jpeg' || info.file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
      return;
    }
    const lessThanImageSize = info.file.size / 1024 / 1024 < 5;
    if (!lessThanImageSize) {
      message.error('Image must be smaller than 5MB!');
      return;
    }

    // Get this url from response in real world.
    getBase64(info.fileList[0].originFileObj, (url) => {
      setLoading(false);
      const trimmedUrl = url.replace(/^data:image\/\w+;base64,/, '')
      setImageUrl(trimmedUrl);
      setValue("logo", trimmedUrl, {shouldDirty: true});
      setFileList(
        [{
          uid: '-1',
          name: 'image.png',
          status: 'done',
          url: url,
        },]
      );
    });

    setNewLogoCheck(true);
  };

  const handleCancel = () => setViewImageModal(false);

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: 'none',
      }}
      type="button"
    >
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Choose File
      </div>
    </button>
  );

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setViewImageModal(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };

  const deleteImageSettings = async () => {
    const response = await deleteImageSetting(imageSettings?.imageSettingsId)

    dispatch(
      setNotificationData({
        type: `${response.ok ? "success" : "error"}`,
        message: `${response.ok ? "Success!" : "Error!"}`,
        description: `${response.ok ? "Successfully deleted" : "Failed to delete"
          } image.`,
      })
    );

    if (response.ok) {
      setImageUrl("");
      setFileList([]);
      deleteImageSettingToggle();
      setIsFormEdit(false);
      setNewLogoCheck(false);
      dispatch(setFormPendingCompletion(false));
      reset({}, {keepValues: true});
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <div className='content-section-container h-50 color-6-section'>
        <div className='d-flex flex-row align-items-center mb-5'>
        </div>
        <form className="d-flex flex-row justify-content-between align-items-center mx-auto form-container" id="image-form" onSubmit={handleSubmit(async (payload) => onSubmit(payload, false))}>
          {/* <div className="col-6 col-sm-6 mb-2 text-center"> */}
          <div className="col-6 col-sm-6 mb-2 text-center text-sm-end pe-3">
            <Controller
              control={control}
              name='logo'
              register={register}
              render={({ field: { onChange, onBlur, name, value, ref } }) => (
                <Upload
                  name="avatar"
                  onPreview={handlePreview}
                  listType="picture-circle"
                  className="avatar-uploader"
                  showUploadList={false}
                  beforeUpload={() => { return false; }}
                  onChange={handleAddChange}
                  maxCount={1}
                >
                  {uploadButton}
                </Upload>
              )}
            />
            <small className='form-error-message'>
              {errors?.cell && errors.cell.message}
            </small>
          </div>
          <div className="col-6 col-sm-6 mb-2 text-center text-sm-start ps-3">
            {fileList.length > 0 ?
              <Upload
                listType="picture-circle"
                fileList={fileList}
                onPreview={handlePreview}
                onRemove={deleteImageSettingToggle}
                maxCount={1}
              >
                {fileList.length >= 1 ? null : null}
              </Upload>
              :
              <Image
                width={100}
                src="data:image/png;base64,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"
              />
            }

          </div>
        </form>
        <div className="col-12 col-sm-12 mt-4 mb-2 text-center">
          <Button className={`mx-auto btn btn-md btn-primary`} form="image-form" type="button" onClick={addImageSettingToggle} icon={<UploadOutlined />} disabled={!newLogoCheck}>
            Upload
          </Button>
        </div>
        <ShowImageModal
          isOpen={viewImageModal}
          toggle={viewImageToggle}
          headerText="Image"
          actionType='primary'
          previewImage={previewImage}
          confirmButtonText="Ok"
        />
        <ConfirmationModal
          isOpen={addImageSettingModal}
          toggle={addImageSettingToggle}
          onClick={handleSubmit(async (payload) => onSubmit(payload, false))}
          headerText="Upload Image"
          bodyText="Are you sure you want to upload this image?"
          confirmButtonText="Yes"
          cancelButtonText="No"
          buttonColor="danger"
          actionType='progress'
        />
        <ConfirmationModal
          isOpen={deleteImageSettingModal}
          toggle={deleteImageSettingToggle}
          onClick={deleteImageSettings}
          headerText="Delete Image"
          bodyText="Are you sure you want to delete this image?"
          confirmButtonText="Yes"
          cancelButtonText="No"
          buttonColor="danger"
          actionType='delete'
        />
      </div>
    </>
  )
}

export default ImageSettingsForm